import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { AngularMyDatePickerModule } from '@nodro7/angular-mydatepicker';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import { ScankomponenteLibModule } from 'scankomponente-lib';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import * as cfg from './app.config';
import { AssistantService } from './common/assistant.service';
import { DateUtilsService } from './common/date-utils.service';
import { DateService } from './common/date.service';
import { DATEPICKER_CONFIG, DATEPICKER_CONFIG_OBJECT } from './common/datepicker-config';
import { EncryptSignSaveService } from './common/encryptsignsave.service';
import { EnvironmentConfigService } from './common/environment-config.service';
import { FixDateService } from './common/fixDate.service';
import { LanguageCheckService } from './common/language-check.service';
import { LanguageService } from './common/language.service';
import { MarshallerFactory } from './common/marshaller-factory';
import { UserSettingsService } from './common/usersettings.service';
import { ValidationService } from './common/validation.service';
import { AssistantComponent } from './components/assistant/assistant.component';
import { ButtonBarComponent } from './components/button-bar/button-bar.component';
import { CfgVisumComponent } from './components/config/cfg-visum.component';
import { videxDVisumConfig } from './components/config/config-videx-d-visum';
import { ErrorComponent } from './components/error/error.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ImpressumComponent } from './components/impressum/impressum.component';
import { AngabenZurPersonComponent } from './components/visum-erfassung/angaben-zur-person/angaben-zur-person.component';
import { KindComponent } from './components/visum-erfassung/angaben-zur-person/kind/kind.component';
import { StellVertreterComponent } from './components/visum-erfassung/angaben-zur-person/stell-vertreter/stell-vertreter.component';
import { AusweispapiereComponent } from './components/visum-erfassung/ausweispapiere/ausweispapiere.component';
import {
  BerufKurzfristigerAufenthaltComponent
} from './components/visum-erfassung/beruf-kurzfristiger-aufenthalt/beruf-kurzfristiger-aufenthalt.component';
import {
  BiometrieKurzfristigerAufenthaltComponent
} from './components/visum-erfassung/biometrie-kurzfristiger-aufenthalt/biometrie-kurzfristiger-aufenthalt.component';
import { DokumenteComponent } from './components/visum-erfassung/dokumente/dokumente.component';
import { EinreisegenehmigungComponent } from './components/visum-erfassung/einreisegenehmigung/einreisegenehmigung.component';
import { FingerabdruckComponent } from './components/visum-erfassung/fingerabdruck/fingerabdruck.component';
import { KontaktdatenComponent } from './components/visum-erfassung/kontaktdaten/kontaktdaten.component';
import { KostenuebernahmeComponent } from './components/visum-erfassung/kostenuebernahme/kostenuebernahme.component';
import { ErklaerungComponent } from './components/visum-erfassung/lebensunterhalt-aufenthaltsdetails/erklaerung/erklaerung.component';
import {
  FruehereAufenthalteComponent
} from './components/visum-erfassung/lebensunterhalt-aufenthaltsdetails/fruehere-aufenthalte/fruehere-aufenthalte.component';
import {
  LebensunterhaltAufenthaltsdetailsComponent
} from './components/visum-erfassung/lebensunterhalt-aufenthaltsdetails/lebensunterhalt-aufenthaltsdetails.component';
import {
  AbweichenderVerpflichtungsgeberComponent
} from './components/visum-erfassung/lebensunterhalt-aufenthaltsdetails/lebensunterhalt/abweichender-verpflichtungsgeber/abweichender-verpflichtungsgeber.component';
import { LebensunterhaltComponent } from './components/visum-erfassung/lebensunterhalt-aufenthaltsdetails/lebensunterhalt/lebensunterhalt.component';
import {
  LebensunterhaltKurzfristigerAufenthaltComponent
} from './components/visum-erfassung/lebensunterhalt-kurzfristiger-aufenthalt/lebensunterhalt-kurzfristiger-aufenthalt.component';
import { LichtbildComponent } from './components/visum-erfassung/lichtbild/lichtbild.component';
import { PruefblattComponent } from './components/visum-erfassung/pruefblatt/pruefblatt.component';
import { AkkreditierterDiplomatComponent } from './components/visum-erfassung/referenz/akkreditierter-diplomat/akkreditierter-diplomat.component';
import { AnmietungGewerblichComponent } from './components/visum-erfassung/referenz/anmietung-gewerblich/anmietung-gewerblich.component';
import { AnmietungPrivatComponent } from './components/visum-erfassung/referenz/anmietung-privat/anmietung-privat.component';
import { EuBuergerComponent } from './components/visum-erfassung/referenz/eu-buerger/eu-buerger.component';
import { HotelComponent } from './components/visum-erfassung/referenz/hotel/hotel.component';
import { OrganisationComponent } from './components/visum-erfassung/referenz/organisation/organisation.component';
import { ReferenzComponent } from './components/visum-erfassung/referenz/referenz.component';
import { ReferenzpersonComponent } from './components/visum-erfassung/referenz/referenzperson/referenzperson.component';
import { WohnungsinhaberComponent } from './components/visum-erfassung/referenz/wohnungsinhaber/wohnungsinhaber.component';
import {
  ReisedatenKurzfristigerAufenthaltComponent
} from './components/visum-erfassung/reisedaten-kurzfristiger-aufenthalt/reisedaten-kurzfristiger-aufenthalt.component';
import { ReisedatenComponent } from './components/visum-erfassung/reisedaten/reisedaten.component';
import { ReisekostenComponent } from './components/visum-erfassung/reisekosten/reisekosten.component';
import { StatusBarComponent } from './components/visum-erfassung/status-bar/status-bar.component';
import { StickernummerComponent } from './components/visum-erfassung/stickernummer/stickernummer.component';
import {
  VerpflichtungserklaerungsgeberComponent
} from './components/visum-erfassung/verpflichtungserklaerungsgeber/verpflichtungserklaerungsgeber.component';
import { VerwandterComponent } from './components/visum-erfassung/verwandter/verwandter.component';
import { VisumErfassungSubFormComponent } from './components/visum-erfassung/visum-erfassung-sub-form/visum-erfassung-sub-form.component';
import { VisumErfassungComponent } from './components/visum-erfassung/visum-erfassung.component';
import { ZusaetzlicheAngabenComponent } from './components/visum-erfassung/zusaetzliche-angaben/zusaetzliche-angaben.component';
import { VisumFormComponent } from './components/visum-form.component';
import { CaptchaInterceptor } from './core/interceptor/captcha.interceptor';
import { AutofocusDirective } from './directives/autofocus.directive';
import { DynamicDateMaxLengthDirective } from './directives/dynamic-date-max-length.directive';
import { FixDateConditionallyDirective } from './directives/fix-date-conditionally.directive';
import { FixDateDirective } from './directives/fix-date.directive';
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';
import { ReadonlyBehaviourDirective } from './directives/readonly-behaviour.directive';
import { ResetDateSpecialValuesDirective } from './directives/reset-date-special-values.directive';
import { SaveLastFocussedConditionallyDirective } from './directives/save-last-focussed-conditionally.directive';
import { SaveLastFocussedDirective } from './directives/save-last-focussed.directive';
import { ToUpperCaseConditionallyDirective } from './directives/to-upper-case-conditionally.directive';
import { ToUpperCaseDirective } from './directives/to-upper-case.directive';
import { EntriesPipe } from './models/rest/pipes/entries-pipe';
import { ValueListFilterPipe } from './models/rest/pipes/value-list-filter.pipe';
import { ButtonLabelComponent } from './shared/components/button-with-cooldown/button-label/button-label.component';
import { ButtonWithCooldownComponent } from './shared/components/button-with-cooldown/button-with-cooldown.component';
import { CardSecondaryTextsComponent } from './shared/components/card-secondary/card-secondary-texts/card-secondary-texts.component';
import { CardSecondaryComponent } from './shared/components/card-secondary/card-secondary.component';
import { CheckboxGroupTextsComponent } from './shared/components/checkbox-group/checkbox-group-texts/checkbox-group-texts.component';
import { CheckboxGroupComponent } from './shared/components/checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './shared/components/checkbox/checkbox.component';
import { DateComponent } from './shared/components/date/date.component';
import { InputComponent } from './shared/components/input/input.component';
import {
  PassRestrictedCheckboxTextsComponent
} from './shared/components/pass-restricted-checkbox/pass-restricted-checkbox-texts/pass-restricted-checkbox-texts.component';
import { PassRestrictedCheckboxComponent } from './shared/components/pass-restricted-checkbox/pass-restricted-checkbox.component';
import { SelectComponent } from './shared/components/select/select.component';

export const initializeApp = (languageCheckService: LanguageCheckService) => {
  return () => languageCheckService.initializeApp();
};

export const loadUSerSettings = (userSettingsService: UserSettingsService) => {
  return () => {
    userSettingsService.fetchUserSettings();
    return userSettingsService.userSettings$.pipe(take(1));
  };
};

export const loadEnvConfig = (environmentConfigService: EnvironmentConfigService) => {
  return () => environmentConfigService.fetchEnvConfig();
};

export const loadValidationMetadata = (validationService: ValidationService) => {
  return () => validationService.fetchValidationMetadata();
};

@NgModule({
  declarations: [
    AppComponent,
    VisumFormComponent,
    HeaderComponent,
    FooterComponent,
    VisumErfassungComponent,
    StatusBarComponent,
    StickernummerComponent,
    AngabenZurPersonComponent,
    KontaktdatenComponent,
    FingerabdruckComponent,
    BiometrieKurzfristigerAufenthaltComponent,
    LichtbildComponent,
    DokumenteComponent,
    AusweispapiereComponent,
    ReisedatenComponent,
    ReisedatenKurzfristigerAufenthaltComponent,
    EinreisegenehmigungComponent,
    ReferenzComponent,
    LebensunterhaltAufenthaltsdetailsComponent,
    LebensunterhaltComponent,
    AbweichenderVerpflichtungsgeberComponent,
    FruehereAufenthalteComponent,
    ErklaerungComponent,
    ButtonBarComponent,
    KindComponent,
    VerwandterComponent,
    PruefblattComponent,
    VisumErfassungSubFormComponent,
    FixDateDirective,
    CfgVisumComponent,
    ToUpperCaseDirective,
    EntriesPipe,
    ValueListFilterPipe,
    BerufKurzfristigerAufenthaltComponent,
    ZusaetzlicheAngabenComponent,
    AssistantComponent,
    KostenuebernahmeComponent,
    ReisekostenComponent,
    LebensunterhaltKurzfristigerAufenthaltComponent,
    VerpflichtungserklaerungsgeberComponent,
    ImpressumComponent,
    SaveLastFocussedDirective,
    ReadonlyBehaviourDirective,
    ErrorComponent,
    ReferenzpersonComponent,
    OrganisationComponent,
    HotelComponent,
    AkkreditierterDiplomatComponent,
    EuBuergerComponent,
    WohnungsinhaberComponent,
    InputComponent,
    SaveLastFocussedConditionallyDirective,
    ToUpperCaseConditionallyDirective,
    SelectComponent,
    DateComponent,
    FixDateConditionallyDirective,
    AnmietungPrivatComponent,
    AnmietungGewerblichComponent,
    PreventDoubleClickDirective,
    AutofocusDirective,
    DynamicDateMaxLengthDirective,
    ResetDateSpecialValuesDirective,
    ButtonWithCooldownComponent,
    ButtonLabelComponent,
    PassRestrictedCheckboxComponent,
    PassRestrictedCheckboxTextsComponent,
    StellVertreterComponent,
    CardSecondaryComponent,
    CardSecondaryTextsComponent,
    CheckboxComponent,
    CheckboxGroupComponent,
    CheckboxGroupTextsComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ScankomponenteLibModule,
    NgxSpinnerModule,
    AppRoutingModule,
    NgbModule,
    AngularMyDatePickerModule], providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [LanguageCheckService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: loadUSerSettings,
      deps: [UserSettingsService]
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: loadEnvConfig,
      deps: [EnvironmentConfigService]
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: loadValidationMetadata,
      deps: [ValidationService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaptchaInterceptor,
      multi: true
    },
    { provide: DATEPICKER_CONFIG, useValue: DATEPICKER_CONFIG_OBJECT },
    // Eine asynchrone Variante findet man unter:
    // https://stackoverflow.com/questions/40827754/angular2-asynchronous-dependency-injection
    { provide: cfg.APP_CONFIG, useValue: videxDVisumConfig },
    AssistantService,
    CookieService,
    Title,
    DateService,
    DateUtilsService,
    FixDateService,
    EntriesPipe,
    DatePipe,
    NgbPopoverConfig,
    MarshallerFactory,
    EncryptSignSaveService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {

  private RTL_LANGUAGES = ['ar', 'fa'];

  constructor(ngbPopoverConfig: NgbPopoverConfig, private languageService: LanguageService) {
    ngbPopoverConfig.placement = 'bottom';
    ngbPopoverConfig.triggers = 'focusin';

    ngbPopoverConfig.disablePopover = true;
    ngbPopoverConfig.autoClose = false;

    const rtlClassRequired = this.RTL_LANGUAGES.indexOf(this.languageService.getLanguage()) >= 0;
    const body: HTMLElement = document.getElementsByTagName('body').item(0);
    if (rtlClassRequired) {
      body.classList.add('rtl');
    } else {
      body.classList.remove('rtl');
    }
  }
}
